module.exports = __webpack_public_path__ + "static/blog24-2b32c7c0955d330cdf60c2e3e0c7adb3.png";